/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExternalProviderLegalForms } from './';
import {
    ExternalProviderLegalFormsFromJSON,
    ExternalProviderLegalFormsFromJSONTyped,
    ExternalProviderLegalFormsToJSON,
} from './';
import type { LegalDetailsTemplate } from './';
import {
    LegalDetailsTemplateFromJSON,
    LegalDetailsTemplateFromJSONTyped,
    LegalDetailsTemplateToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyTypeView
 */
export interface CompanyTypeView {
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeView
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeView
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeView
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeView
     */
    language?: string;
    /**
     * 
     * @type {LegalDetailsTemplate}
     * @memberof CompanyTypeView
     */
    legalNoticesTemplate: LegalDetailsTemplate;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeView
     */
    legalPersonType: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeView
     */
    userType: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyTypeView
     */
    enabled: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CompanyTypeView
     */
    creationDate: Date;
    /**
     * 
     * @type {Array<ExternalProviderLegalForms>}
     * @memberof CompanyTypeView
     */
    legalFormMappings: Array<ExternalProviderLegalForms>;
}

/**
 * Check if a given object implements the CompanyTypeView interface.
 */
export function instanceOfCompanyTypeView(value: object): value is CompanyTypeView {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('legalNoticesTemplate' in value) || value['legalNoticesTemplate'] === undefined) return false;
    if (!('legalPersonType' in value) || value['legalPersonType'] === undefined) return false;
    if (!('userType' in value) || value['userType'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('legalFormMappings' in value) || value['legalFormMappings'] === undefined) return false;
    return true;
}

export function CompanyTypeViewFromJSON(json: any): CompanyTypeView {
    return CompanyTypeViewFromJSONTyped(json, false);
}

export function CompanyTypeViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyTypeView {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'country': json['country'],
        'label': json['label'],
        'language': json['language'] == null ? undefined : json['language'],
        'legalNoticesTemplate': LegalDetailsTemplateFromJSON(json['legalNoticesTemplate']),
        'legalPersonType': json['legalPersonType'],
        'userType': json['userType'],
        'enabled': json['enabled'],
        'creationDate': (new Date(json['creationDate'])),
        'legalFormMappings': ((json['legalFormMappings'] as Array<any>).map(ExternalProviderLegalFormsFromJSON)),
    };
}

export function CompanyTypeViewToJSON(value?: CompanyTypeView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'country': value['country'],
        'label': value['label'],
        'language': value['language'],
        'legalNoticesTemplate': LegalDetailsTemplateToJSON(value['legalNoticesTemplate']),
        'legalPersonType': value['legalPersonType'],
        'userType': value['userType'],
        'enabled': value['enabled'],
        'creationDate': ((value['creationDate']).toISOString()),
        'legalFormMappings': ((value['legalFormMappings'] as Array<any>).map((v) => ExternalProviderLegalFormsToJSON(v))),
    };
}

